var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#00BDF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2425 38.1328L34.6622 10.5084C35.4019 10.5084 36.7575 10.5759 36.7575 12.404V38.9906C36.7575 39.7303 36.1584 40.3294 35.4187 40.3294H12.8681C12.1284 40.3322 11.2425 39.6684 11.2425 38.1328Z",
    fill: "#A15D38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2425 38.1694V11.7769C11.2425 11.0709 11.8134 10.5 12.5194 10.5H34.62C35.3259 10.5 35.8969 11.0709 35.8969 11.7769V38.1694C35.8969 38.8753 35.3259 39.4462 34.62 39.4462H12.5194C11.8134 39.4462 11.2425 38.8753 11.2425 38.1694Z",
    fill: "#BA793E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0016 36.8419V13.0369C14.0016 12.6741 14.2969 12.3788 14.6597 12.3788H32.7778C33.1406 12.3788 33.436 12.6741 33.436 13.0369V36.8419C33.436 37.2047 33.1406 37.5 32.7778 37.5H14.6597C14.2969 37.5 14.0016 37.2075 14.0016 36.8419Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8703 21.2888H30.5672",
    stroke: "#B0BEC5",
    strokeWidth: 0.84375,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8703 18.0685H30.5672",
    stroke: "#B0BEC5",
    strokeWidth: 0.84375,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8703 24.5091H30.5672",
    stroke: "#B0BEC5",
    strokeWidth: 0.84375,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8703 27.7322H30.5672",
    stroke: "#B0BEC5",
    strokeWidth: 0.84375,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8703 30.9525H30.5672",
    stroke: "#B0BEC5",
    strokeWidth: 0.84375,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8703 34.1729H22.7287",
    stroke: "#B0BEC5",
    strokeWidth: 0.84375,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M30.4491 13.9875V10.5084H26.5172L28.9669 13.9875H30.4491Z",
    fill: "#212121"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9403 10.6378L27.0347 10.6238C26.4328 10.6238 26.3203 10.0894 26.2978 9.97688C26.2669 9.83063 26.2275 9.5072 26.2106 9.37782C26.0588 8.11501 25.6256 7.33876 24.0478 7.15876C22.6809 7.00407 21.6994 8.40751 21.6994 9.74626C21.6994 9.74907 21.6994 9.7547 21.6994 9.75751C21.7022 10.3622 21.2438 10.8684 20.6391 10.8684C20.6391 10.8684 18.8728 10.5675 17.61 12.0131C17.3738 12.2831 17.0897 13.3969 17.0869 13.7091C17.0813 14.5781 17.8322 14.6934 18.0938 14.6963C19.2694 14.7047 28.8459 14.6738 29.7628 14.6738C30.1397 14.6738 30.4463 14.3672 30.4463 13.9903V13.4813C30.4491 12.0356 29.3831 10.6378 27.9403 10.6378ZM23.9691 10.7138C23.4488 10.7138 23.0269 10.2919 23.0269 9.77157C23.0269 9.25126 23.4488 8.82938 23.9691 8.82938C24.4894 8.82938 24.9113 9.25126 24.9113 9.77157C24.9113 10.2919 24.4894 10.7138 23.9691 10.7138Z",
    fill: "#2F7889"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4256 10.4972H26.88C26.2781 10.4972 26.0362 10.0247 25.9603 9.86157C25.8506 9.6225 25.8197 9.13594 25.8 9.00657C25.6425 8.01375 24.8128 7.22625 23.8144 7.11938C22.4475 6.97032 21.2887 8.03907 21.2887 9.375C21.2887 9.37782 21.2887 9.38344 21.2887 9.38625C21.2916 9.99094 20.8331 10.4972 20.2284 10.4972H19.694C18.2512 10.4972 17.0812 11.6672 17.0812 13.11V13.6191C17.0812 13.9959 17.3878 14.3025 17.7647 14.3025H29.3522C29.729 14.3025 30.0356 13.9959 30.0356 13.6191V13.11C30.0384 11.6672 28.8684 10.4972 27.4256 10.4972ZM23.5584 10.3453C23.0381 10.3453 22.6162 9.92344 22.6162 9.40313C22.6162 8.88282 23.0381 8.46094 23.5584 8.46094C24.0787 8.46094 24.5006 8.88282 24.5006 9.40313C24.5006 9.92344 24.0787 10.3453 23.5584 10.3453Z",
    fill: "#82AEC0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2103 12.1988H18.6253C18.2597 12.1988 18.1641 11.9934 18.3525 11.6813C18.6281 11.2284 19.2863 10.9303 19.8488 10.9303C21.0694 10.9303 25.4738 10.7953 27.0234 10.7953C27.78 10.7953 28.1738 11.0484 28.5028 11.4703C28.7363 11.7741 28.59 12.1988 28.2103 12.1988Z",
    fill: "#B9E4EA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0256 8.66626C22.1831 8.02501 22.7878 7.84219 22.7878 7.84219",
    stroke: "#B9E4EA",
    strokeWidth: 0.595266,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list-icon.64582581cdf1bf32f93d4235e8bb5e57.svg";
export { ForwardRef as ReactComponent };